import { Link } from "react-router-dom";

export default function PublicFooter() {
  return (
    <footer className="border-t border-slate-200 bg-[#0b1327] text-slate-300">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-12 md:grid-cols-[1.5fr_1fr_1fr] md:px-8">
        <div>
          <div className="font-display text-2xl font-black text-white">Audit Pro</div>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-400">
            Workspace compliance per consulenti e aziende: checklist operative, audit versionati, evidenze documentali e report esecutivi.
          </p>
        </div>
        <div>
          <div className="text-sm font-semibold text-white">Navigazione</div>
          <div className="mt-4 flex flex-col gap-2 text-sm text-slate-400">
            <Link to="/product" className="hover:text-white">Prodotto</Link>
            <Link to="/pricing" className="hover:text-white">Prezzi</Link>
            <Link to="/contact" className="hover:text-white">Demo</Link>
          </div>
        </div>
        <div>
          <div className="text-sm font-semibold text-white">Accesso</div>
          <div className="mt-4 flex flex-col gap-2 text-sm text-slate-400">
            <Link to="/auth/login" className="hover:text-white">Login</Link>
            <Link to="/app" className="hover:text-white">Area riservata</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
